<template>
  <router-view ref="page" v-else/>
</template>
<script>
export default {
  name: 'EmptyPageView'
}
</script>



// WEBPACK FOOTER //
// src/views/common/EmptyPageView.vue